// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-26ZV5";
var _4 = "emojy-9LfZv";
var _5 = "title-3UB_v";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "emojy", _5 as "title" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "emojy": _4, "title": _5 }
